import{j as e}from"./chunk-GEPA7FLG.js";e();import{gql as n}from"@apollo/client";var d=n`
  query nftFarmDetails(
    $address: String!
    $groupId: String!
    $rewardToken: String!
    $isRewardTokenLocked: Boolean!
  ) {
    nftFarmDetails(
      address: $address
      groupId: $groupId
      rewardToken: $rewardToken
      isRewardTokenLocked: $isRewardTokenLocked
    ) {
      unboundPeriod
      unstaked {
        identifier
        collection
        url
        ticker
        name
        nonce
        media {
          thumbnailUrl
        }
      }
      staked {
        identifier
        collection
        ticker
        url
        name
        nonce
        media {
          thumbnailUrl
        }
      }
      unbound {
        identifier
        collection
        ticker
        name
        url
        nonce
        media {
          thumbnailUrl
        }
        unlockDate
      }
      claimable {
        identifier
        collection
        ticker
        name
        url
        nonce
        media {
          thumbnailUrl
        }
      }
    }
  }
`;export{d as a};
//# sourceMappingURL=chunk-A2HJ65OZ.js.map
